import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function PrivateRoute({ children }) {
  const { accessToken, loading } = useAuth();

  if (loading) return null; // wait for silent refresh before deciding

  if (!accessToken) return <Navigate to="/" replace />;

  return children;
}
